import { ActionSettingType } from "@/constants/unit"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type ActionSettingStoreType = {
  isAllValid: { [key in ActionSettingType]: boolean }
  hasChanges: { [key in ActionSettingType]: boolean }
  setIsAllValid: (type: ActionSettingType, isValid: boolean) => void
  setHasChanges: (type: ActionSettingType, isValid: boolean) => void
}

export const createActionSettingState = create<ActionSettingStoreType>()(
  devtools(
    (set) => ({
      isAllValid: {
        [ActionSettingType.RUN]: true,
        [ActionSettingType.ACCELERATION]: true,
        [ActionSettingType.DECELERATION]: true,
        [ActionSettingType.JUMP]: true,
        [ActionSettingType.DIVE]: true,
        [ActionSettingType.COD]: true,
      },
      hasChanges: {
        [ActionSettingType.RUN]: false,
        [ActionSettingType.ACCELERATION]: false,
        [ActionSettingType.DECELERATION]: false,
        [ActionSettingType.JUMP]: false,
        [ActionSettingType.DIVE]: false,
        [ActionSettingType.COD]: false,
      },
      setIsAllValid: (type, isValid) =>
        set((state) => ({
          isAllValid: {
            ...state.isAllValid,
            [type]: isValid,
          },
        })),
      setHasChanges: (type, isValid) =>
        set((state) => ({
          hasChanges: {
            ...state.hasChanges,
            [type]: isValid,
          },
        })),
    }),
    {
      store: "actionSetting",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)

// Zone Setting Store
export enum ZoneSettingType {
  SPEED = "speed",
  ACCELERATION = "acceleration",
  DECELERATION = "deceleration",
  HR = "hr",
}

export type ZoneSettingStoreType = {
  isAllValid: { [key in ZoneSettingType]: boolean }
  hasChanges: { [key in ZoneSettingType]: boolean }
  setIsAllValid: (type: ZoneSettingType, isValid: boolean) => void
  setHasChanges: (type: ZoneSettingType, isValid: boolean) => void
}

export const createZoneSettingState = create<ZoneSettingStoreType>()(
  devtools(
    (set) => ({
      isAllValid: {
        [ZoneSettingType.SPEED]: true,
        [ZoneSettingType.ACCELERATION]: true,
        [ZoneSettingType.DECELERATION]: true,
        [ZoneSettingType.HR]: true,
      },
      hasChanges: {
        [ZoneSettingType.SPEED]: false,
        [ZoneSettingType.ACCELERATION]: false,
        [ZoneSettingType.DECELERATION]: false,
        [ZoneSettingType.HR]: false,
      },
      setIsAllValid: (type, isValid) =>
        set((state) => ({
          isAllValid: {
            ...state.isAllValid,
            [type]: isValid,
          },
        })),
      setHasChanges: (type, hasChanges) =>
        set((state) => ({
          hasChanges: {
            ...state.hasChanges,
            [type]: hasChanges,
          },
        })),
    }),
    {
      store: "zoneSetting",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
